import React from "react";
import Header from "./components/common/header";
import { Outlet } from "react-router-dom";
import Footer from "./components/footer";

const Main = () => {
  return (
    <div className="bg-black text-neutral-50">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Main;
